import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ShareModule } from 'src/app/share-module';
import { ComponentsModule } from 'src/app/components/components-module';
import { LoginComponent } from './login/login.component';
import { RegisterComponent } from './register/register.component';
import { RegisterActivationComponent } from './register-activation/register-activation.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { TvLoginComponent } from './tv-login/tv-login.component';

@NgModule({
    imports: [
        CommonModule,
        ShareModule,
        ComponentsModule
    ],
    declarations: [
        LoginComponent,
        RegisterComponent,
        RegisterActivationComponent,
        ResetPasswordComponent,
        TvLoginComponent
    ]
})

export class SubscriberModule { }